import { Component } from '@angular/core';

@Component({
    selector: 'app-employee-layout',
    templateUrl: './employee-layout.component.html',
    styleUrls: ['./employee-layout.component.scss']
})
export class EmployeeLayoutComponent {}
